
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ComponentDocs, Preview } from "@lighting-beetle/lighter-styleguide";
import List, { ListItem } from "./index";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Lists`}</h1>
    <h2>{`Example`}</h2>
    <List mdxType="List">
  <ListItem mdxType="ListItem">Laborum laboris amet minim.</ListItem>
  <ListItem mdxType="ListItem">Quis adipisicing eu consectetur.</ListItem>
  <ListItem mdxType="ListItem">Et anim sit do nisi.</ListItem>
  <ListItem mdxType="ListItem">Deserunt id consectetur esse in.</ListItem>
    </List>
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <List mdxType="List">
    <ListItem mdxType="ListItem">Laborum laboris amet minim.</ListItem>
    <ListItem mdxType="ListItem">Quis adipisicing eu consectetur.</ListItem>
    <ListItem mdxType="ListItem">Et anim sit do nisi.</ListItem>
    <ListItem mdxType="ListItem">Deserunt id consectetur esse in.</ListItem>
  </List>
    </Preview>
    <h3>{`Clean`}</h3>
    <Preview mdxType="Preview">
  <List clean mdxType="List">
    <ListItem mdxType="ListItem">Laborum laboris amet minim.</ListItem>
    <ListItem mdxType="ListItem">Quis adipisicing eu consectetur.</ListItem>
    <ListItem mdxType="ListItem">Et anim sit do nisi.</ListItem>
    <ListItem mdxType="ListItem">Deserunt id consectetur esse in.</ListItem>
  </List>
    </Preview>
    <h3>{`Bordered`}</h3>
    <Preview mdxType="Preview">
  <List bordered mdxType="List">
    <ListItem mdxType="ListItem">Laborum laboris amet minim.</ListItem>
    <ListItem mdxType="ListItem">Quis adipisicing eu consectetur.</ListItem>
    <ListItem mdxType="ListItem">Et anim sit do nisi.</ListItem>
    <ListItem mdxType="ListItem">Deserunt id consectetur esse in.</ListItem>
  </List>
    </Preview>
    <h3>{`Condensed`}</h3>
    <Preview mdxType="Preview">
  <List condensed mdxType="List">
    <ListItem mdxType="ListItem">Laborum laboris amet minim.</ListItem>
    <ListItem mdxType="ListItem">Quis adipisicing eu consectetur.</ListItem>
    <ListItem mdxType="ListItem">Et anim sit do nisi.</ListItem>
    <ListItem mdxType="ListItem">Deserunt id consectetur esse in.</ListItem>
  </List>
    </Preview>
    <h2>{`Clickable item`}</h2>
    <Preview mdxType="Preview">
  <List mdxType="List">
    <ListItem clickable mdxType="ListItem">Laborum laboris amet minim.</ListItem>
    <ListItem clickable mdxType="ListItem">Quis adipisicing eu consectetur.</ListItem>
  </List>
    </Preview>
    <h2>{`Selected item`}</h2>
    <Preview mdxType="Preview">
  <List mdxType="List">
    <ListItem mdxType="ListItem">Laborum laboris amet minim.</ListItem>
    <ListItem isSelected mdxType="ListItem">Quis adipisicing eu consectetur.</ListItem>
    <ListItem mdxType="ListItem">Et anim sit do nisi.</ListItem>
  </List>
    </Preview>
    <h2>{`Disabled item`}</h2>
    <Preview mdxType="Preview">
  <List mdxType="List">
    <ListItem mdxType="ListItem">Laborum laboris amet minim.</ListItem>
    <ListItem isDisabled mdxType="ListItem">Quis adipisicing eu consectetur.</ListItem>
    <ListItem mdxType="ListItem">Et anim sit do nisi.</ListItem>
  </List>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<List />" component={List} mdxType="ComponentDocs" />
    <ComponentDocs title="<ListItem />" component={ListItem} mdxType="ComponentDocs" />
    <h2>{`Accessibility`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`<List />`}</inlineCode>{` component currently only renders as unordered list.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;